/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CcmLeakedResourceStatusEnum } from './ccmLeakedResourceStatusEnum';


/**
 * A cleanup candidate resource
 */
export interface CloudCostMgmtLeakedResource { 
    /**
     * AWS service name
     */
    service: string;
    /**
     * Resource type
     */
    type?: string;
    /**
     * AWS resource identifier
     */
    resource_id: string;
    /**
     * Resource name
     */
    name?: string;
    /**
     * AWS region
     */
    region?: string;
    /**
     * Reason for being a cleanup candidate
     */
    reason?: string;
    /**
     * Estimated monthly savings in USD
     */
    savings?: number;
    status: CcmLeakedResourceStatusEnum;
    /**
     * Additional metadata about the resource
     */
    metadata?: { [key: string]: any; };
    /**
     * Timestamp when the resource was cleaned
     */
    cleaned_ts?: Date;
    /**
     * Timestamp when the resource was first detected
     */
    created_ts?: Date;
    /**
     * Timestamp when the resource was last updated
     */
    updated_ts?: Date;
}
export namespace CloudCostMgmtLeakedResource {
}


